<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="part03"><a id="page_27"></a><strong>III<br/>THE RANGERS AND THE REPUBLIC</strong></h2>
<p class="noindentm"><em>The white man and the red man cannot dwell in harmony together. Nature forbids it</em>.</p>
<p class="att"><em>President</em> M. B. L<span class="small">AMAR</span></p>
<p class="noindentm"><em>So, the government provided for their protection as best it could with the means at its disposal, graciously permitting the citizens to protect themselves by organizing … ranging companies</em>.</p>
<p class="att">N<span class="small">OAH</span> S<span class="small">MITHWICK</span></p>
<p class="noindentm"><em>The river and its banks now presented every evidence of a total defeat of our savage foe. The bodies of men, women, and children were to be seen on every hand wounded, dying, and dead</em>.</p>
<p class="att"><em>Colonel</em> J<span class="small">OHN</span> H. M<span class="small">OORE</span><a id="page_28"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part03.vue?6a534ed5